export const hoursEn = {
  copyDialog: {
    copyToOtherDays: 'Copy to other days',
  },
  dayGroups: {
    weekdays: 'Weekdays',
    weekends: 'Weekends',
  },
  days: {
    fri: 'Fri',
    mon: 'Mon',
    sat: 'Sat',
    sun: 'Sun',
    thu: 'Thu',
    tue: 'Tue',
    wed: 'Wed',
  },
  notifications: {
    'special-hours': {
      create: {
        error: 'Unable to create special hours',
        success: 'Special hours created',
      },
      delete: {
        error: 'Unable to delete special hours',
        success: 'Special hours deleted',
      },
      update: {
        error: 'Unable to update special hours',
        success: 'Special hours updated',
      },
    },
  },
  sidebar: {
    specialHours: {
      deleteDialog: {
        action: 'Delete special hours',
        prompt:
          "Are you sure you want to delete special hours for {date}? This can't be undone.",
        title: 'Delete special hours?',
      },
      formView: {
        buttons: {
          cancel: 'Cancel',
          delete: 'Delete',
          save: 'Save',
        },
        dateLabel: 'Date',
        datePlaceholder: 'mm/dd/yyyy',
        hoursLabel: 'Hours',
        repeatLabel: 'Repeat every year',
        title: {
          add: 'Add special hours',
          edit: 'Edit special hours',
        },
      },
      listView: {
        addButton: 'Add special hours',
        subtitle:
          'Dates when your hours of business are different than your regular store hours',
        title: 'Special hours',
      },
    },
  },
  status: {
    closed: 'Closed',
    open24Hours: 'Open 24 hours',
  },
}
